export default __webpack_public_path__ + "static/media/gift.ce81bfe9.svg";